import React from "react";
import { css } from "@emotion/css";
import { Breakpoint } from "theme";

const ContentPage: React.FC = ({ children }) => <div className={styles.page}>{children}</div>;

export default ContentPage;

const styles = {
  page: css`
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    margin: 0 auto;
    padding: 16px 24px 48px;

    @media screen and (max-width: ${Breakpoint.sm}px) {
      padding: 12px 12px 32px;
    }
  `,
};
